<template>
  <div class="media-editor-container scrollable">
    <div class="media-editor-tabs-panel">
      <!-- Media type (MP4/GIF) switching tabs -->
      <media-tabs-panel
        v-model="mediaTab"
        class="media-tabs"
        :tabs="mediaTabLabels"
        @deleteAll="handleDeleteAll"
      />
    </div>
    <div class="mediaBackground">
      <!-- Videos list -->
      <div v-if="mediaTab == 'clips'">
        <el-row v-if="clipItems.length">
          <template v-for="item in sortedVideos">
            <el-col :key="item.id" :span="24">
              <video-item
                :ref="'video_items'"
                :channels="channels"
                :thumbnail-link="item.thumbnailLink"
                :download-link="item.downloadLink"
                :media-items-list="mediaItems"
                :media-tab="mediaTab"
                :open-modal-express="openModalExpressSharing"
                :video-info="item"
                :snapchat-link="getSnapchatLink(item.downloadLink)"
                @updateTitleStart="updateTitleStart"
                @updateTitleFinish="updateTitleFinish"
                @updateDescFinish="updateDescFinish"
                @gif="generateGIF(item)"
                @cut="cutVideo(item.id, $event)"
                @download="
                  downloadMedia(
                    item.downloadLink,
                    item.title,
                    item.stream,
                    item.id
                  )
                "
                @copy="copyMediaLink(item.downloadLink)"
                @cloneVideoItemObj="cloneVideoItem"
                @delete="
                  showDeleteDialog($options.removeDialogType.VIDEO, {
                    id: item.id,
                    title: item.title
                  })
                "
                @uploadToMangomolo="
                  uploadToMangomolo(
                    item.id,
                    item.downloadLink,
                    $event.title,
                    $event.titleArabic,
                    $event.description,
                    $event.stream,
                    $event.categoryVideoinfo,
                    $event.done
                  )
                "
                @updatePoster="updatePoster(item.id, $event)"
                @stopPlayer="$emit('stopPlayer')"
                @sharingRemoved="
                  $emit('sharingRemoved', {
                    videoId: item.id,
                    sharingId: $event.id
                  })
                "
                @playVideoInMediaManager="
                  $emit('playVideoInMediaManager', $event)
                "
              />
            </el-col>
          </template>
        </el-row>
        <el-row v-else>
          <el-col :span="24">
            <p>No Clips For Now</p>
          </el-col>
        </el-row>
      </div>

      <!-- GIFs list -->
      <div v-if="mediaTab == 'gifs'">
        <div class="gifs-panel">
          <div v-if="gifItems.length" class="gifs-grid">
            <div v-for="item in gifItems" :key="item.id" class="gif-container">
              <gif-item
                :info="item"
                @download="downloadMedia(item.link)"
                @remove="
                  showDeleteDialog($options.removeDialogType.GIF, {
                    id: item.id
                  })
                "
              />
            </div>
          </div>
          <el-row v-else>
            <el-col :span="24">
              <p>No GIFs For Now</p>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- Download list -->
      <div v-show="mediaTab === 'upload'">
        <el-radio-group v-model="radioUploading" class="radioOffset">
          <el-radio-button label="Drag and drop"></el-radio-button>
          <el-radio-button label="Upload by url"></el-radio-button>
        </el-radio-group>

        <div class="gifs-panels">
          <div v-show="radioUploading === 'Upload by url'">
            <el-input
              v-model="UploadUrl"
              class="inputUploadUrl"
              placeholder="Please enter the url. Example: http//site.com/video.mp4"
              clearable
            >
            </el-input>
            <div>
              <el-button
                v-if="radioUploading === 'Upload by url'"
                slot="tip"
                :disabled="isDisabled"
                type="success"
                class="el-upload__tip"
                @click="submitUpload"
                >Upload
                <!-- {{ uploadPercentage }} -->
              </el-button>
            </div>
            <div class="uploadLinkUrl">
              Uploaded by user in list
              <!-- {{ uploadedByUserUrl.join(" ") }} -->
            </div>
          </div>

          <div v-show="radioUploading === 'Drag and drop'">
            <el-upload
              ref="upload"
              class="upload-demo"
              drag
              :on-remove="handleRemove"
              :show-file-list="showList"
              :action="'undefined'"
              :accept="checkUploadFormat"
              :before-upload="onBeforeUpload"
              :auto-upload="false"
              :file-list="fileList"
              :on-change="handleChange"
              multiple
            >
              <a class="el-upload-list__item-name"
                ><i class="el-icon-upload"></i
              ></a>
              <div class="el-upload__text">
                Drop file here or <em>click to upload</em>
              </div>
            </el-upload>
            <div>
              <el-button
                v-if="radioUploading === 'Drag and drop'"
                slot="tip"
                :disabled="isDisabled"
                type="success"
                class="el-upload__tip"
                @click="submitUpload"
                >Upload
                <!-- {{ uploadPercentage }} -->
              </el-button>
            </div>
            <div class="uploadDragEndDrop">
              Uploaded by user in list
              <!-- {{ uploadedByUser.join(" ") }} -->
            </div>
          </div>
          <el-row v-if="clipItems.length">
            <template v-for="item in sortedUpload">
              <el-col :key="item.id" :span="24">
                <video-item
                  :thumbnail-link="item.thumbnailLink"
                  :download-link="item.downloadLink"
                  :media-items-list="mediaItems"
                  :percent-completed="uploadingProcess"
                  :video-info="item"
                  :snapchat-link="getSnapchatLink(item.downloadLink)"
                  @updateTitleStart="updateTitleStart"
                  @updateTitleFinish="updateTitleFinish"
                  @gif="generateGIF(item)"
                  @cut="cutVideo(item.id, $event)"
                  @download="downloadMedia(item.downloadLink, item.title)"
                  @copy="copyMediaLink(item.downloadLink)"
                  @delete="
                    showDeleteDialog($options.removeDialogType.VIDEO, {
                      id: item.id,
                      title: item.title
                    })
                  "
                  @uploadToMangomolo="
                    uploadToMangomolo(
                      item.id,
                      item.downloadLink,
                      item.title,
                      $event.titleArabic,
                      $event.description,
                      $event.stream,
                      $event.categoryVideoinfo,
                      $event.done
                    )
                  "
                  @updatePoster="updatePoster(item.id, $event)"
                  @stopPlayer="$emit('stopPlayer')"
                  @sharingRemoved="
                    $emit('sharingRemoved', {
                      videoId: item.id,
                      sharingId: $event.id
                    })
                  "
                  @playVideoInMediaManager="
                    $emit('playVideoInMediaManager', $event)
                  "
                />
              </el-col>
            </template>
          </el-row>
          <el-row v-if="audioItems.length">
            <template v-for="item in sortedUpload">
              <el-col :key="item.id" :span="24">
                <audio-item
                  :channels="channels"
                  :title="item.title"
                  :percent-completed="uploadingProcess"
                  :start-time="new Date(item.startTime * 1000)"
                  :end-time="new Date(item.endTime * 1000)"
                  :duration="item.metadata.duration"
                  :snapchat-link="getSnapchatLink(item.downloadLink)"
                  :app="app"
                  :audio-info="item"
                  :media-items-list="mediaItems"
                  :stream="stream"
                  :status="item.status"
                  :is-removable="item.isRemovable"
                  :progress="item.progress"
                  @updateTitle="updateAudioTitle(item.id, $event)"
                  @preview="
                    openAudioPreview(item.downloadLink, item.title, item.id)
                  "
                  @download="downloadMedia(item.downloadLink, item.title)"
                  @copy="copyMediaLink(item.downloadLink)"
                  @stopPlayer="$emit('stopPlayer')"
                  @delete="
                    showDeleteDialog($options.removeDialogType.AUDIO, {
                      id: item.id,
                      title: item.title
                    })
                  "
                  @uploadToMangomolo="
                    uploadToMangomolo(
                      item.id,
                      item.downloadLink,
                      $event.title,
                      $event.titleArabic,
                      $event.description,
                      $event.stream,
                      $event.categoryVideoinfo
                    )
                  "
                />
              </el-col>
            </template>
          </el-row>
          <el-row v-else>
            <el-col :span="24">
              <p v-if="channelType === 'audio'">No Audios For Now</p>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- Audios list -->
      <div v-if="mediaTab == 'audios'">
        <el-row v-if="audioItems.length && channelType === 'audio'">
          <template v-for="item in sortedAudios">
            <el-col :key="item.id" :span="24">
              <audio-item
                :channels="channels"
                :title="item.title"
                :start-time="new Date(item.startTime * 1000)"
                :end-time="new Date(item.endTime * 1000)"
                :duration="item.metadata.duration"
                :app="app"
                :audio-info="item"
                :media-items-list="mediaItems"
                :stream="stream"
                :status="item.status"
                :is-removable="item.isRemovable"
                :progress="item.progress"
                @updateTitle="updateAudioTitle(item.id, $event)"
                @preview="
                  openAudioPreview(item.downloadLink, item.title, item.id)
                "
                @download="downloadMedia(item.downloadLink, item.title)"
                @copy="copyMediaLink(item.downloadLink)"
                @stopPlayer="$emit('stopPlayer')"
                @delete="
                  showDeleteDialog($options.removeDialogType.AUDIO, {
                    id: item.id,
                    title: item.title
                  })
                "
                @uploadToMangomolo="
                  uploadToMangomolo(
                    item.id,
                    item.downloadLink,
                    $event.title,
                    $event.titleArabic,
                    $event.description,
                    $event.stream,
                    $event.categoryVideoinfo
                  )
                "
              />
            </el-col>
          </template>
        </el-row>
        <el-row v-else>
          <el-col :span="24">
            <p v-if="channelType === 'audio'">No Audios For Now</p>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- Delete video confirmation form -->
    <remove-confirmation
      :visible="isDeleteDialogVisible"
      :message="currentRemoveDialogParameters.text"
      :title="currentRemoveDialogParameters.title"
      @delete="deleteMedia"
      @close="closeDeleteDialog"
    />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { getAPI, token } from "@/api/params.js";

import MediaTabsPanel from "@/components/media/MediaTabsPanel.vue";
import VideoItem from "@/components/media/video/VideoItem.vue";
import GifItem from "@/components/media/video/GifItem.vue";
import AudioItem from "@/components/media/audio/AudioItem.vue";
import RemoveConfirmation from "@/components/dialog/RemoveConfirmation.vue";

import mediaApi from "@/api/media/media.js";
import { editVideo } from "@/api/edit.js";
import { EDIT_TYPE } from "@/constants.js";

import { REMOVE_MEDIA_DIALOG_TYPE } from "@/constants.js";

import copy from "clipboard-copy";
import { saveAs } from "file-saver";

// @group Media
// Clips list component
export default {
  name: "MediaEditor",
  components: {
    MediaTabsPanel,
    VideoItem,
    GifItem,
    AudioItem,
    RemoveConfirmation
  },
  props: {
    channels: {
      type: Array
    },
    /** Media item lists container */
    mediaItems: {
      type: Object,
      default() {
        return {
          clips: [],
          gifs: [],
          audios: [],
          upload: []
        };
      }
    },
    openModalExpressSharing: {
      type: Number
    }
  },
  data() {
    return {
      /** delete video */
      isDeleteDialogVisible: false,
      removeDialogType: REMOVE_MEDIA_DIALOG_TYPE.VIDEO,
      removeMediaId: null,
      removeMediaTitle: null,
      /** current tab */
      mediaTab: null,
      fileList: [],
      uploadedCount: 0,
      itemsFiles: [],
      showList: true,
      uploadPercentage: 0,
      UploadUrl: "",
      radioUploading: "Drag and drop",
      isDisabled: true,
      uploadedByUser: [],
      uploadedByUserUrl: [],
      uploadingProcess: 0
    };
  },
  removeDialogType: REMOVE_MEDIA_DIALOG_TYPE,
  computed: {
    ...mapGetters(["channelType"]),
    ...mapState({
      /** stream info */
      app: state => state.services.app,
      stream: state => state.services.stream,
      mangomoloChannelId: state => state.services.mangomoloChannelId,
      mangomoloSharingChannelId: state =>
        state.services.sharingChannelIdMangomolo,
      /** storage */
      storagePath: state => state.services.thumbs,
      httpStoragePath: state => state.services.httpStorage,
      isMediaManager: state => state.services.isMediaManager,
      /** modal */
      modals: state => state.modals.clipper.MODALS
    }),
    checkUploadFormat() {
      return this.channelType === "audio" ? ".mp3" : ".mp4,.avi,.mov,.flv,.vob";
    },
    // @vuese
    // Clips list
    clipItems() {
      return this.mediaItems.clips || [];
    },
    // @vuese
    // Gifs list
    gifItems() {
      return this.mediaItems.gifs || [];
    },
    // @vuese
    // Upload list
    uploadItems() {
      return this.mediaItems.upload || [];
    },
    // @vuese
    // Audios list
    audioItems() {
      return this.mediaItems.audios || [];
    },
    checkLengthListClips() {
      return this.mediaItems.clips.length;
    },
    // @vuese
    // Tab objects (value, label) array
    mediaTabLabels() {
      const tabs = [];
      const { clips, gifs, audios, upload } = this.mediaItems;
      if (clips) {
        tabs.push({
          value: "clips",
          label: `Clips ${
            this.checkLengthListClips > 0
              ? "(" + this.checkLengthListClips + ")"
              : ""
          }`,
          clearable: clips.length > 0
        });
      }
      if (gifs) {
        tabs.push({
          value: "gifs",
          label: "GIFs",
          clearable: gifs.length > 0
        });
      }

      if (audios) {
        tabs.push({
          value: "audios",
          label: "Audios",
          clearable: audios.length > 0
        });
      }

      if (upload) {
        tabs.push({
          value: "upload",
          label: `${
            this.channelType === "audio" ? "Audio upload" : "Video upload"
          }`,
          clearable: upload.length > 0
        });
      }

      return tabs;
    },
    // @vuese
    // Default tab label when no selected
    defaultTab() {
      return this.mediaTabLabels[0].value;
    },
    // @vuese
    // Videos list sorted by creation date
    sortedVideos() {
      // Sort by creation date, from newest to oldest
      const sorted = [...this.clipItems].sort(
        (a, b) => b.createdAt - a.createdAt
      );
      return sorted;
    },
    sortedUpload() {
      // Sort by creation date, from newest to oldest
      return this.channelType === "audio"
        ? [...this.audioItems]
            .filter(e => {
              return e.isUploadedByUser;
            })
            .sort((a, b) => b.createdAt - a.createdAt)
        : [...this.clipItems]
            .filter(e => {
              return e.isUploadedByUser;
            })
            .sort((a, b) => b.createdAt - a.createdAt);
      // const sorted = [...this.clipItems]
      //   .filter(e => {
      //     return e.isUploadedByUser;
      //   })
      //   .sort((a, b) => b.createdAt - a.createdAt);
      // return sorted;
    },
    // @vuese
    // Audios list sorted by creation date
    sortedAudios() {
      // Sort by creation date, from newest to oldest
      const sorted = [...this.audioItems].sort(
        (a, b) => b.createdAt - a.createdAt
      );
      return sorted;
    },
    // @vuese
    // Text of confirm video remove message
    removeVideoMessage() {
      return `Are you sure, that you want to delete "${this.removeMediaTitle}" clip file?`;
    },
    // @vuese
    // Text of confirm audio remove message
    removeAudioMessage() {
      return `Are you sure, that you want to delete "${this.removeMediaTitle}" audio file?`;
    },
    // @vuese
    // Current title and text for remove dialog
    currentRemoveDialogParameters() {
      return this.removeDialogParameters[this.removeDialogType];
    },
    // @vuese
    // Text and title object for every remove dialog type
    removeDialogParameters() {
      return {
        [REMOVE_MEDIA_DIALOG_TYPE.VIDEO]: {
          title: "Delete video",
          text: this.removeVideoMessage
        },
        [REMOVE_MEDIA_DIALOG_TYPE.ALL_VIDEOS]: {
          title: "Delete all videos",
          text: "Are you sure, that you want to delete ALL videos?"
        },
        [REMOVE_MEDIA_DIALOG_TYPE.GIF]: {
          title: "Delete GIF",
          text: "Are you sure that you want delete this GIF?"
        },
        [REMOVE_MEDIA_DIALOG_TYPE.ALL_GIFS]: {
          title: "Delete all GIFs",
          text: "Are you sure, that you want to delete ALL GIFs?"
        },
        [REMOVE_MEDIA_DIALOG_TYPE.AUDIO]: {
          title: "Delete audio",
          text: this.removeAudioMessage
        },
        [REMOVE_MEDIA_DIALOG_TYPE.ALL_AUDIOS]: {
          title: "Delete all audios",
          text: "Are you sure, that you want to delete ALL audios?"
        },
        [REMOVE_MEDIA_DIALOG_TYPE.UPLOAD]: {
          title: "Delete all uploads",
          text: "Are you sure, that you want to delete ALL uploads?"
        }
      };
    }
  },
  watch: {
    // @vuese
    // Set default tab when selected no in available tans list
    openModalExpressSharing(value) {
      const openModalForExpress = () => {
        try {
          for (const item of this.$refs.video_items) {
            if (item.info.id == value) {
              item.isShowSharingModal = true;
              return;
            }
          }
        } catch (err) {
          console.log("opening the modal window failed");
        }
        setTimeout(openModalForExpress, 1000);
      };
      openModalForExpress();
    },
    mediaItems() {
      if (!(this.mediaTab in this.mediaItems)) {
        this.mediaTab = this.defaultTab;
      }
    },
    itemsFiles() {
      if (this.itemsFiles.length == 0) {
        this.showList = false;
        this.isDisabled = true;
      } else {
        this.showList = true;
        this.isDisabled = false;
      }
    },
    UploadUrl() {
      if (this.UploadUrl.length === 0) {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }
    }
  },
  created() {
    this.mediaTab = this.defaultTab;

    /** check link for Snapchat sharing */
    const { protocol, port } = document.location;

    if (protocol.toLowerCase() != "https:") {
      console.warn("Your site must be on HTTPS to use Snapchat sharing link");
    }

    if (port !== "" && port !== "443") {
      console.warn(
        "Your site must be on port 443 to use Snapchat sharing link"
      );
    }
  },
  methods: {
    ...mapActions("modals", {
      openModal: "openClipperModal"
    }),
    cloneVideoItem(arrCloneVideo) {
      //clone video
      this.$emit("cloneItemVideo", arrCloneVideo);
    },
    submitUpload() {
      let stream;
      if (this.stream === "No Stream") {
        stream = null;
      } else {
        stream = this.stream;
      }
      const videoUploadDrugDrop = `${getAPI()}/video/uploader/get_uploading_link?token=${token}&app=ndvr${
        stream ? "&stream=" + stream : ""
      }`;
      const audioUploadDrugDrop = `${getAPI()}/audio/uploader/get_uploading_link?token=${token}&app=ndvr${
        stream ? "&stream=" + stream : ""
      }`;
      if (this.radioUploading === "Drag and drop") {
        fetch(
          `${
            this.channelType === "audio"
              ? audioUploadDrugDrop
              : videoUploadDrugDrop
          }`,
          {
            method: "POST",
            body: JSON.stringify({
              items: this.itemsFiles.map(file => {
                return { fileName: file.name };
              })
            }),
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json"
            }
          }
        )
          .then(response => response.json())
          .then(commits => {
            if (commits.success === true) {
              this.$refs.upload.clearFiles();
            } else {
              ("error");
            }
            const uploadingLinkUrl = commits.data.uploadingUrl;
            const files = this.itemsFiles.slice();
            this.itemsFiles = [];

            function postData(url, data, onProgress) {
              return new Promise(function(resolve, reject) {
                const request = new XMLHttpRequest();
                request.open("POST", url);
                request.upload.onprogress = function(e) {
                  const percent_completed = (e.loaded / e.total) * 100;
                  onProgress(percent_completed);
                };
                request.onerror = reject;
                request.addEventListener("readystatechange", function(e) {
                  console.warn(request.readyState);
                  if (request.status < 300) {
                    resolve({
                      status: request.status,
                      response: request.response
                    });
                  } else {
                    reject({
                      status: request.status,
                      response: request.response
                    });
                  }
                });
                request.send(data);
              });
            }

            Promise.all(
              commits.data.item.map((item, index) => {
                const formdata = new FormData();
                formdata.append("file", files[index].raw, item.fileName);
                formdata.append("token", item.uploadingToken);
                formdata.append("callback_url", item.callbackUrl);
                formdata.append("file_size", files[index].size);
                formdata.append("isUploadedByUser", item.isUploadedByUser);
                formdata.append("isMultistepSource", item.isMultistepSource);

                const requestOptions = {
                  url: uploadingLinkUrl,
                  method: "post",
                  data: formdata,
                  onUploadProgress: function(progressEvent) {
                    this.uploadPercentage = parseInt(
                      Math.round(
                        (progressEvent.loaded / progressEvent.total) * 100
                      )
                    );
                  }.bind(this)
                };
                return postData(uploadingLinkUrl, formdata, e => {
                  this.uploadingProcess = Number(e.toFixed());
                });
              })
            );
            files.forEach(item => this.uploadedByUser.push(item.name));
            // this.uploadedByUser.push(files[0].name);
            this.showSuccess("File uploaded in clips");
          });
      } else {
        const checkUrl = /^(https?|HTTP?)\:\/\/\S+\/\S*[^.]\S*$/.test(
          this.UploadUrl
        );
        const urlDownloadAudio = `${getAPI()}/audio/uploader/get_uploading_link?token=${token}&app=ndvr&stream=${
          this.stream
        }`;
        const urlDownloadVideo = `${getAPI()}/video/uploader/get_uploading_link?token=${token}&app=ndvr&stream=${
          this.stream
        }`;
        if (checkUrl) {
          fetch(
            `${
              this.channelType === "audio" ? urlDownloadAudio : urlDownloadVideo
            }`,
            {
              method: "POST",
              body: JSON.stringify({
                items: [
                  {
                    fileName: this.UploadUrl
                  }
                ]
              }),
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              }
            }
          )
            .then(response => response.json())
            .then(
              function(commits) {
                if (commits.success === true) {
                  this.$refs.upload.clearFiles();
                } else {
                  ("error");
                }
                const uploadingLinkUrl = commits.data.uploadingUrl;
                const files = [this.UploadUrl];

                function postData(url, data, onProgress) {
                  return new Promise(function(resolve, reject) {
                    const request = new XMLHttpRequest();
                    request.open("POST", url);
                    request.onprogress = function(e) {
                      const percent_completed = (e.loaded / e.total) * 100;
                      onProgress(percent_completed);
                    };
                    request.onerror = reject;
                    request.addEventListener("readystatechange", function(e) {
                      console.warn(request.readyState);
                      if (request.status < 300) {
                        resolve({
                          status: request.status,
                          response: request.response
                        });
                      } else {
                        reject({
                          status: request.status,
                          response: request.response
                        });
                      }
                    });
                    request.send(data);
                  });
                }

                Promise.all(
                  commits.data.item.map((item, index) => {
                    const formdata = new FormData();
                    formdata.append("token", item.uploadingToken);
                    formdata.append("callback_url", item.callbackUrl);
                    formdata.append("file_url", this.UploadUrl);

                    return postData(uploadingLinkUrl, formdata, function(e) {});
                  })
                );
                this.UploadUrl = "";
                this.uploadedByUserUrl.push(files[0]);
              }.bind(this)
            );
          this.showSuccess("File uploaded in clips");
        } else {
          this.showError("Invalid url");
        }
      }
    },
    handleChange(file) {
      this.itemsFiles.push(file);
    },
    onBeforeUpload(file) {
      const isLimit = file.size / 1024 / 1024 < 10000;
      if (!isLimit) {
        this.$message.error("Upload file size cannot exceed 10 GB!");
      }
      return isLimit;
    },

    handleRemove(file) {
      this.itemsFiles = this.itemsFiles.filter(itemsFiles => {
        return itemsFiles !== file;
      });
    },
    // @vuese
    // Remove selected media item
    async deleteMedia({ done }) {
      const deleteFunctionsMap = {
        [REMOVE_MEDIA_DIALOG_TYPE.VIDEO]: this.deleteVideo,
        [REMOVE_MEDIA_DIALOG_TYPE.GIF]: id =>
          mediaApi.removeGIF(id, this.app, this.stream),
        [REMOVE_MEDIA_DIALOG_TYPE.AUDIO]: id =>
          mediaApi.removeAudio(id, this.app, this.stream),
        [REMOVE_MEDIA_DIALOG_TYPE.ALL_VIDEOS]: this.deleteAllVideos,
        [REMOVE_MEDIA_DIALOG_TYPE.ALL_GIFS]: mediaApi.removeAllGIFs.bind(
          this,
          this.app,
          this.stream
        ),
        [REMOVE_MEDIA_DIALOG_TYPE.ALL_AUDIOS]: mediaApi.removeAllAudios.bind(
          this,
          this.app,
          this.stream
        )
      };

      const deleteMedia = deleteFunctionsMap[this.removeDialogType];
      try {
        await deleteMedia(this.removeMediaId);
        this.showSuccess("Removed Successfully");
      } catch (err) {
        this.showError("Remove Failed", err);
      } finally {
        done();
      }
    },
    // @vuese
    // Remove video
    async deleteVideo(id) {
      // Video information updating is stopped, for data safe reason
      this.$emit("stopUpdateVideos");
      try {
        await mediaApi.removeVideo(id, this.app, this.stream);
      } finally {
        // Video information updating is started again
        this.$emit("continueUpdateVideos");
      }
    },
    // @vuese
    // Remove all videos for stream
    async deleteAllVideos() {
      // Video information updating is stopped, for data safe reason
      this.$emit("stopUpdateVideos");
      try {
        await mediaApi.removeAllVideos(this.app, this.stream);
      } finally {
        // Video information updating is started again
        this.$emit("continueUpdateVideos");
      }
    },
    // @vuese
    // Show audio preview modal
    // @arg audio playing link <br>
    // @arg audio name
    openAudioPreview(link, name, id) {
      if (!this.isMediaManager) {
        this.openModal({
          modal: this.modals.WATCH_AUDIO,
          data: {
            name,
            link: link
          }
        });
      } else {
        this.$emit("playAudioInMediaManager", id);
      }
    },
    // @vuese
    // Return link with storage prefix
    // @arg link - relative link in storage
    getStorageLink(link) {
      return `${this.storagePath}/${link}`;
    },
    // @vuese
    // Return link to share link item to Snapchat
    // @arg link - origin link that need to be shared
    getSnapchatLink(link) {
      /** get host and check that page is valid */
      const { protocol, hostname, port } = document.location;

      if (protocol.toLowerCase() != "https:") {
        return null;
      }

      if (port !== "" && port !== "443") {
        return null;
      }

      const fullLink = `https://${hostname}?watch=${link}`;
      const encodedDownloadLink = encodeURIComponent(fullLink);
      return `https://www.snapchat.com/scan?attachmentUrl=${encodedDownloadLink}`;
    },
    // @vuese
    // Return link to upload to Mangomolo
    // @arg link - uploaded media
    getMangomoloLink(link) {
      return `${this.httpStoragePath}/${link}`;
    },
    // @vuese
    // Download media file by link
    // @arg link - media link
    // @arg name - file name
    downloadMedia(link, name = "download", stream, videoId) {
      //for admin logs
      fetch(`${getAPI()}/action-logs/log-download?token=${token}`, {
        method: "POST",
        body: JSON.stringify({ stream, videoId }),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: token
        }
      });
      const ext = /\.[^.]+$/.exec(link);
      const filename = name + ext;
      saveAs(link, filename);
    },
    // @vuese
    // Copy link to clipboard
    // @arg media link
    copyMediaLink(link) {
      copy(link);
      this.$notify({
        group: "foo",
        position: "top right",
        type: "success",
        title: "Copied",
        text: link
      });
    },

    async uploadToMangomolo(
      id,
      link,
      title,
      titleArab,
      description,
      stream,
      categoryId,
      done
    ) {
      const mangomoloLink = link;
      if (this.channelType === "audio") {
        try {
          await mediaApi.uploadToMangomoloAudio(
            id,
            mangomoloLink,
            title,
            titleArab,
            description,
            stream,
            categoryId,
            undefined,
            undefined,
            this.mangomoloSharingChannelId
          );
          this.$notify({
            group: "foo",
            type: "success",
            title: "Success",
            text: "Upload request has been sent"
          });
        } catch (err) {
          this.$notify({
            group: "foo",
            type: "error",
            title: "Uploading Failed",
            text: err
          });
        } finally {
          done();
        }
      } else {
        try {
          await mediaApi.uploadToMangomolo(
            id,
            mangomoloLink,
            title,
            titleArab,
            description,
            stream,
            categoryId,
            undefined,
            undefined,
            this.mangomoloSharingChannelId
          );
          this.$notify({
            group: "foo",
            type: "success",
            title: "Success",
            text: "Upload request has been sent"
          });
        } catch (err) {
          this.$notify({
            group: "foo",
            type: "error",
            title: "Uploading Failed",
            text: err
          });
        } finally {
          done();
        }
      }
    },
    async updatePoster(id, { done, success }) {
      try {
        const link = await mediaApi.generateThumbnail(id);
        success(link);
      } catch (error) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "Error update thumbnail",
          text: error.message
        });
      } finally {
        done();
      }
    },
    // @vuese
    // Convert clip to GIF
    async generateGIF(clipData) {
      const { duration, width } = clipData.metadata;
      if (duration > 60) {
        this.showError(
          "GIF generating error",
          "Video duration must be less or equal than 60 seconds"
        );
        return;
      }

      const gifTemplate = {
        startOffset: 1,
        duration: 60,
        scaleWidth: 320,
        inFps: "10",
        outputFps: "10",
        looped: true,
        frameLimit: 24,
        mode: "slides"
      };

      const gifParams = {
        ...gifTemplate,
        duration: duration,
        scaleWidth: width,
        frameLimit: duration * 24
      };

      try {
        await mediaApi.generateGIF(
          clipData.id,
          gifParams,
          this.app,
          this.stream
        );
        this.showSuccess("GIF generating started");
      } catch (error) {
        this.showError("GIF generating error", error);
      }
    },
    // @vuese
    // Create new clips from the clip by cutting ranges
    // @arg id - internal video ID <br>
    // @arg event - object with two keys: ranges (list of cut ranges), done (callback function that received list of boolean success flags)
    async cutVideo(id, { ranges, done, inverse, failed, transitionType }) {
      if (!inverse) {
        /** unite all request promises into one */
        const promises = ranges.map(([start, end], index) => {
          editVideo(id, { [EDIT_TYPE.TRIM]: { start, end, index } });
        });
        const results = await Promise.allSettled(promises);

        /** parse results */
        const statuses = results.map(({ value, status, reason }) => ({
          success: status === "fulfilled" || value?.success,
          error: reason ?? value?.error ?? null
        }));

        /** handle failed results */
        const failed = statuses.filter(({ success }) => !success);
        for (const { error } of failed) {
          this.showError("Clip Trimming Error", error);
          console.error(error);
          failed();
        }

        /** if no one request has failed - show success notification */
        const allDone = statuses.every(({ success }) => success);
        if (allDone) {
          this.showSuccess("Trim Started");
        }

        /** call cut form's done callback */
        const succesFlags = statuses.map(({ success }) => success);
        done(succesFlags);
      } else {
        try {
          await editVideo(id, {
            [EDIT_TYPE.CONCAT]: {
              intervals: ranges,
              transitionType
            }
          });
          this.showSuccess("Trim Started");
          done();
        } catch (error) {
          this.showError("Clip Trimming Error", error);
          console.error(error);
          failed();
        }
      }
    },
    // @vuese
    // Show delete all media dialog
    // @arg remove dialog type
    handleDeleteAll(type) {
      switch (type) {
        case "clips":
          this.showDeleteDialog(REMOVE_MEDIA_DIALOG_TYPE.ALL_VIDEOS, {});
          break;
        case "gifs":
          this.showDeleteDialog(REMOVE_MEDIA_DIALOG_TYPE.ALL_GIFS, {});
          break;
        case "audios":
          this.showDeleteDialog(REMOVE_MEDIA_DIALOG_TYPE.ALL_AUDIOS, {});
          break;
        case "upload":
          this.showDeleteDialog(REMOVE_MEDIA_DIALOG_TYPE.UPLOAD, {});
          break;
        default:
          console.warn(`Unknown type of media: <${type}>`);
      }
    },
    // @vuese
    // Show delete media dialog
    // @arg type - remove dialog media type <br>
    // @arg { id, title } - media id and media title
    showDeleteDialog(type, { id = null, title = null }) {
      this.removeDialogType = type;
      this.removeMediaId = id;
      this.removeMediaTitle = title;
      this.isDeleteDialogVisible = true;
    },
    // @vuese
    // Hide removing video confirmation modal
    closeDeleteDialog() {
      this.isDeleteDialogVisible = false;
    },
    // @vuese
    // Switch media editor list to "GIFs" tab
    showGIFsPanel() {
      this.mediaTab = "gifs";
    },
    updatePanel() {
      this.mediaTab = "update";
    },
    // @vuese
    // Switch media editor list to "MP4" tab
    showClipsPanel() {
      this.mediaTab = "clips";
    },
    // @vuese
    // Stops videos updating for to prevent errors, while title will be editing
    updateTitleStart() {
      // User edit video information
      this.$emit("stopUpdateVideos");
    },
    // @vuese
    // Change video title and allow videos information updating
    // @arg info - changing video information
    async updateTitleFinish(info) {
      try {
        mediaApi.setVideoTitle(info.id, info.title, this.app, this.stream);
        this.showSuccess(
          "Update Video Title Success",
          "Video Title Successfully Updated"
        );
      } catch (e) {
        this.showError(
          "Update Video Title Error",
          `Update Title Is Failed: ${e}`
        );
      } finally {
        // User finished video editing
        this.$emit("continueUpdateVideos");
      }
    },
    async updateDescFinish(info) {
      try {
        await mediaApi.setVideoDescription(
          info.id,
          info.description,
          this.app,
          this.stream
        );
        this.showSuccess(
          "Update Video Description Success",
          "Video Description Successfully Updated"
        );
      } catch (e) {
        this.showError(
          "Update Video Description Error",
          `Update Description Is Failed: ${e}`
        );
      } finally {
        // User finished video editing
        this.$emit("continueUpdateVideos");
      }
    },
    // @vuese
    // Change audio file name
    // @arg id - audio ID <br>
    // @arg title - audio title
    async updateAudioTitle(id, title) {
      try {
        await mediaApi.setAudioTitle(id, title, this.app, this.stream);
        this.showSuccess(
          "Update Audio Title Success",
          "Audio Title Successfully Updated"
        );
      } catch (err) {
        this.showError("Title Changing Failed", err);
      }
    },

    // @vuese
    // Standard error notification
    // @arg title - error title <br>
    // @arg error - error description
    showError(title, error = "") {
      this.$notify({
        group: "foo",
        position: "bottom right",
        type: "error",
        title: title,
        text: error
      });
    },
    // @vuese
    // Standard success notification
    // @arg title - success title <br>
    // @arg message - success description
    showSuccess(title, message = "") {
      this.$notify({
        group: "foo",
        position: "bottom right",
        type: "success",
        title: title,
        text: message
      });
    }
  }
};
</script>

<style lang="scss">
.upload-demo {
  display: flex;
  flex-direction: column;
  margin: 0 auto;
}

.radioOffset {
  margin-bottom: 10px;
}

.el-upload-dragger {
  background-color: #fff;
  border: 1px dashed #080808;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 220px;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  overflow: hidden;
}

.inputUploadUrl {
  border: 1px solid white;
  border-radius: 4px;
}

.el-upload-dragger .el-icon-upload {
  font-size: 67px;
  color: #c0c4cc;
  margin: 70px 0 16px;
  padding: 0px 140px;
  line-height: 50px;
}
.el-upload-list {
  margin: 0 auto;
  padding: 0;
  list-style: none;
  display: block;
  display: inline-block;
}

.uploadDragEndDrop {
  margin-bottom: 20px;
}

.uploadLinkUrl {
  margin-bottom: 20px;
}

.listLeft {
  text-align: left;
  margin-bottom: 10px;
}

.el-upload-list__item-name {
  color: #ffffff;
}

.el-progress__text {
  color: #ffffff;
}

.el-upload-dragger .el-upload__text {
  color: black;
}

.el-upload__tip {
  background: #67c23a;
  margin: 25px auto;
  color: #ffffff;
  border-radius: 4px;
  height: 40px;
  font-size: 15px;
}
.el-upload__tip:hover {
  background: #5fb04a;
}

.el-upload-dragger .el-upload__text em {
  color: #409eff;
  font-style: normal;
}

.el-upload-list__item .el-progress {
  display: none;
}

.el-upload-list__item .el-icon-upload-success {
  display: none;
}

.media-editor-container {
  height: 100%;

  display: flex;
  flex-direction: column;
}

.media-tabs {
  width: 100%;
}

.mediaBackground {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  /*border-top: 1px solid #b2b2b2;*/
  border: 1px solid transparent;

  display: block;
  overflow: auto;
  /** position: absolute; */
}

.titleUploadVideo {
  margin-top: 45%;
  cursor: pointer;
}

.gifs-grid {
  display: grid;
  grid-template-columns: calc(50% - 7.5px) calc(50% - 7.5px);
  grid-gap: 10px 15px;
}

.message {
  /* */
  color: var(--grey);
}
.remove-all-grid-container {
  align-self: center;
  justify-self: center;
  grid-column: 1 / span 2;
}
.remove-all-btn {
  margin-right: auto;
  margin-left: auto;
  margin-top: 10px;
  margin-bottom: 16px;
  padding: 10px 8px 10px 8px;

  font-size: 14px;
}
/** media queries */
@media only screen and (max-width: 767px) {
  .gifs-grid {
    grid-template-columns: 100%;
  }
  .remove-all-btn {
    width: 100%;
  }
}
</style>
